import { UserSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const USER_TABLE = '"public"."profiles"'

export const UserConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: USER_TABLE,
  partitionKey: 'workspace_id',
  key: 'id',
  apiEndpoint: '/api/users',
  where: {},
  schema: UserSchema,
}
